import { USERS_ROUTES } from '../../constants/_routes'
import usersTypes from '../../constants/usersTypes'
import { axios } from '../../services'

// INDEX
const users_xlsx_request = () => {
  return {
    type: usersTypes.xlsx.request
  }
}

const users_xlsx_success = () => {
  return {
    type: usersTypes.xlsx.success
  }
}

const users_xlsx_failure = (messages) => {
  return {
    type: usersTypes.xlsx.failure,
    payload: messages
  }
}

const users_xlsx = (filters={}, sort="", order="", variant="user") => {
  return function (dispatch) {
    // Before Request
    dispatch(users_xlsx_request())
    document.body.classList.add('instalevel-fetching-data')

    axios.get(
      `${USERS_ROUTES.index}.xlsx`,
      {
        params: {
          sort: sort,
          order: order,
          filters: filters,
          variant: variant
        },
        responseType: 'blob'
      }
    ).then( response => {
      // success
      const blob = URL.createObjectURL(response.data, "mitsos")
      const filename = `users_${variant}.xlsx`
      let fileLink = document.createElement('a')
      document.body.appendChild(fileLink);
      fileLink.style="display: none"
      fileLink.href = blob
      fileLink.download = filename
      fileLink.click();
      URL.revokeObjectURL(blob)
      dispatch( users_xlsx_success() )
      document.body.classList.remove('instalevel-fetching-data')
    }).catch( error=> {
      // failure
      document.body.classList.remove('instalevel-fetching-data')
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching xlsx file."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( users_xlsx_failure(errors))
    })
  }
}

export {
  users_xlsx
}



// WEBPACK FOOTER //
// ./src/js/actions/users/getxlsx.js